import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import _ from 'lodash';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import QCXAutocompleteSelect from '../autocomplete-select/QCXAutocompleteSelect';

export default function QCXFinalSelectGenericoAutocomplete({ label = 'Tipo de Frete', name, initialValues, optionsProp, ...restProps }) {
  const [defaultValue, setDefaultValue] = useState('');

  const list = useMemo(
    () => 
      optionsProp
    ,
    []
  );

  useEffect(() => {
    const defaultInitialValue = _.get(initialValues, name);

    const option = list.find((item) => item?.value === defaultInitialValue);

    if (option) {
      setDefaultValue(option);
    } else {
      setDefaultValue('');
    }
  }, [list, initialValues, name]);

  const filterOptions = useMemo(
    () =>
      createFilterOptions({
        stringify: (option) => `${option?.label || ''} ${option?.value || ''}`,
      }),
    []
  );

  const getOptionLabel = useCallback((item) => item?.label || '', []);
  const getOptionValue = useCallback((item) => item?.value || '', []);

  return (
    <QCXAutocompleteSelect
      label={label}
      id={name}
      name={name}
      options={list}
      filterOptions={filterOptions}
      defaultValue={defaultValue}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      {...restProps}
    />
  );
}
